import type { PropsWithChildren } from 'react';
import React from 'react';
import { Card } from 'antd';
import classNames from 'classnames';
import styles from './card-ui.module.scss';

interface ISidebarCardUIProps {
  title?: string | React.ReactNode;
  className?: string;
  loading?: boolean;
}
export const CardUi: React.FC<PropsWithChildren<ISidebarCardUIProps>> = (props) => {
  const { title, children, className, loading } = props;

  const elementClasses = classNames(styles.card, className);
  return (
    <Card className={elementClasses} title={title} loading={loading}>
      {children}
    </Card>
  );
};
